var _circle, _path, _g, _ellipse, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilestoneProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_866_235)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.471 36.3173C61.0604 34.4852 59.2466 33.3338 57.4198 33.7456L38.45 38.0212C36.6231 38.433 35.4751 40.252 35.8856 42.0841L37.9038 51.0893C38.3144 52.9213 40.1281 54.0727 41.955 53.661L60.9248 49.3853C62.7516 48.9735 63.8997 47.1545 63.4891 45.3225L61.471 36.3173Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_866_235)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 46C52.7614 46 55 43.7614 55 41H68V67H32V41H45C45 43.7614 47.2386 46 50 46Z",
    fill: "url(#paint1_linear_866_235)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 41V40.75H54.75V41H55ZM68 41H68.25V40.75H68V41ZM68 67V67.25H68.25V67H68ZM32 67H31.75V67.25H32V67ZM32 41V40.75H31.75V41H32ZM45 41H45.25V40.75H45V41ZM54.75 41C54.75 43.6234 52.6234 45.75 50 45.75V46.25C52.8995 46.25 55.25 43.8995 55.25 41H54.75ZM55 41.25H68V40.75H55V41.25ZM67.75 41V67H68.25V41H67.75ZM68 66.75H32V67.25H68V66.75ZM32.25 67V41H31.75V67H32.25ZM32 41.25H45V40.75H32V41.25ZM50 45.75C47.3766 45.75 45.25 43.6234 45.25 41H44.75C44.75 43.8995 47.1005 46.25 50 46.25V45.75Z",
    fill: "url(#paint2_linear_866_235)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.05125,
    cy: 3.06,
    rx: 3.05125,
    ry: 3.06,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 55.2866 50.9688)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.52562,
    cy: 1.53,
    rx: 1.52562,
    ry: 1.53,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 47.8281 54.0288)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_866_235",
    x: 29.85,
    y: 38.85,
    width: 40.3,
    height: 30.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_866_235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_866_235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_866_235",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_866_235",
    x1: 35.8524,
    y1: 43.3988,
    x2: 68.3987,
    y2: 66.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_866_235",
    x1: 53,
    y1: 45.3333,
    x2: 60.6063,
    y2: 69.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneProject);
export default __webpack_public_path__ + "static/media/milestone-project.5939ccf3630f7d7c795abf3efd472e29.svg";
export { ForwardRef as ReactComponent };